var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountActivation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 188,
    viewBox: "0 0 188 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94 188c51.915 0 94-42.085 94-94S145.915 0 94 0 0 42.085 0 94s42.085 94 94 94z",
    fill: "#88A13B",
    fillOpacity: 0.09
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 140c25.129 0 45.5-20.371 45.5-45.5S118.629 49 93.5 49 48 69.371 48 94.5 68.371 140 93.5 140z",
    fill: "#88A13B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m81.874 115.025 23.396 23.396C124.647 133.254 139 115.6 139 94.501v-1.293l-18.372-16.936-38.754 38.753z",
    fill: "#595959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.804 106.536c2.01 2.009 2.01 5.454 0 7.463L90.5 116c-2.01 2.009-5.454 2.009-7.464 0L64.808 97.628c-2.01-2.01-2.01-5.454 0-7.464l2.303-2c2.01-2.01 5.455-2.01 7.464 0l18.229 18.372z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.036 74.425c2.01-2.01 5.455-2.01 7.464 0l2.707 2.708c2.009 2.01 2.009 5.454 0 7.464L90.629 116.03c-2.009 2.009-5.454 2.009-7.463 0l-2.707-2.708c-2.01-2.01-2.01-5.455 0-7.464l31.577-31.434z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountActivation);
export default __webpack_public_path__ + "static/media/AccountActivation.76f783db5223eb8faf367791d9226939.svg";
export { ForwardRef as ReactComponent };